export const removeScript = (scriptToRemove) => {
  // Clean up Salesforce chatbot widget and session if present
  if (window.embeddedservice_bootstrap) {
    try {
      if (window.embeddedservice_bootstrap.userVerificationAPI?.clearSession) {
        window.embeddedservice_bootstrap.userVerificationAPI.clearSession()
      }
      if (window.embeddedservice_bootstrap.utilAPI?.removeAllComponents) {
        window.embeddedservice_bootstrap.utilAPI.removeAllComponents()
      }
    } catch (e) {
      console.error('Error cleaning up Salesforce chatbot:', e)
    }
  }

  // Remove the Salesforce script tag
  const script = document.querySelector(
    'script[src*="ESWAppHeroStaging1785145908130"]',
  )
  if (script) {
    script.remove()
  }

  // Clean up global function
  delete window.initEmbeddedMessaging

  // Original cleanup logic for standard script elements
  const allScripts = document.getElementsByTagName('script')
  for (let i = allScripts.length - 1; i >= 0; i -= 1) {
    if (
      allScripts[i] &&
      allScripts[i].getAttribute('src') !== null &&
      allScripts[i].getAttribute('src').indexOf(`${scriptToRemove}`) !== -1
    ) {
      allScripts[i].parentNode.removeChild(allScripts[i])
    }
  }
}
